import angular from 'angular';

export class MedicosService {
    static $inject = ['$http', 'nsjRouting', '$q'];

    public constructors: any = {};
    public filters: any = {};
    public loading_deferred: angular.IDeferred<any> | null = null;
    public loading_deferred_filter: angular.IDeferred<any> | null = null;

    constructor(
        public $http: angular.IHttpService,
        public nsjRouting: any,
        public $q: angular.IQService,
    ) {}

    search(filter?: any): angular.IHttpPromise<any> {
        let search = '';

        if (typeof filter !== 'undefined' && filter != null) {
            search = filter.search ? filter.search : '';

            Object.keys(this.filters).forEach((k): void => {
                delete this.filters[k];
            });

            for (const fil in filter.filters) {
                if (fil.indexOf('.') > -1) {
                    const filterSplit = fil.split('.');
                    this.filters[filterSplit[0]] = {};
                    this.filters[filterSplit[0]][filterSplit[1]] = filter.filters[fil];
                } else {
                    this.filters[fil] = filter.filters[fil];
                }
            }
        } else if (filter == null) {
            if (this.loading_deferred_filter) {
                this.loading_deferred_filter.resolve();
            }

            return this._load(this.constructors, {}, '');
        }

        if (filter && filter.lookup && this.loading_deferred_filter) {
            this.loading_deferred_filter.resolve();
        }

        return this._load(this.constructors, {}, search);
    }

    get(id: string): angular.IHttpPromise<any> {
        this.loading_deferred = this.$q.defer();

        return this.$http.get(
            this.nsjRouting.generate('medicos_get', { id }, true),
            { timeout: this.loading_deferred.promise }
        );
    }

    private _load(constructors: any, offset: any, filter: any): angular.IHttpPromise<any> {
        this.loading_deferred = this.$q.defer();
        this.loading_deferred_filter = this.$q.defer();

        return this.$http({
            method: 'GET',
            url: this.nsjRouting.generate('medicos_index', angular.extend({}, constructors, {
                offset,
                filter
            }, this.filters), true),
            timeout: this.loading_deferred_filter.promise
        }).then((response: any) => response.data);
    }
}
